import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-translate-skip": "" }
const _hoisted_2 = { class: "p-the-a01-point-notification-panel-thanks__detail" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-the-a01-point-notification-panel-thanks__detail__text" }
const _hoisted_5 = {
  class: "u-text-weight--bold",
  "data-translate-skip": ""
}
const _hoisted_6 = { class: "p-the-a01-point-notification-panel-thanks__detail__text" }
const _hoisted_7 = {
  class: "u-text-weight--bold",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconNotificationThanks = _resolveComponent("IconNotificationThanks")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_PointNotificationPanelSmall = _resolveComponent("PointNotificationPanelSmall")!

  return (_openBlock(), _createBlock(_component_PointNotificationPanelSmall, {
    type: "thanks",
    url: _ctx.url,
    class: "p-the-a01-point-notification-panel-thanks"
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_IconNotificationThanks)
    ]),
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.thanksPointName), 1),
      _cache[0] || (_cache[0] = _createTextVNode("が", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _cache[2] || (_cache[2] = _createTextVNode("届きました！", -1))
    ]),
    detail: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconUserImage, {
          size: _ctx.iconSize,
          class: "p-the-a01-point-notification-panel-thanks__detail__icon"
        }, {
          default: _withCtx(() => [
            (_ctx.giver.user_image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.giver.user_image,
                  alt: ""
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["size"]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, [
            _cache[3] || (_cache[3] = _createTextVNode(" ポイント数： ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.addComma(_ctx.point)) + " " + _toDisplayString(_ctx.unit), 1)
          ]),
          _createElementVNode("p", _hoisted_6, [
            _cache[4] || (_cache[4] = _createTextVNode(" 送り主：", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.giver.id == 0 ? "－" : _ctx.giver.user_name), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["url"]))
}